import { render, staticRenderFns } from "./PriceCardBig.vue?vue&type=template&id=702c0c76"
import script from "./PriceCardBig.vue?vue&type=script&lang=js"
export * from "./PriceCardBig.vue?vue&type=script&lang=js"
import style0 from "./PriceCardBig.vue?vue&type=style&index=0&id=702c0c76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports